import { render, staticRenderFns } from "./ModalGlobalCertificados.vue?vue&type=template&id=7185a560&scoped=true&"
import script from "./ModalGlobalCertificados.vue?vue&type=script&lang=js&"
export * from "./ModalGlobalCertificados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7185a560",
  null
  
)

export default component.exports